import styled from "styled-components";


export const Container = styled.section`
  margin-top: 12rem;
  padding-bottom: 4rem;

  header{
    text-align: center;
    margin-bottom: 4rem;
    
    h2{
      font-size: 3.5rem;
      margin-bottom: 1rem;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
    
    p{
      font-size: 1.6rem;
      color: #b0b0b0;
      max-width: 500px;
      margin: 0 auto;
      line-height: 1.6;
    }
  }

  .contact-wrapper {
    display: grid;
    grid-template-columns: 1fr 1.5fr;
    gap: 4rem;
    align-items: start;
  }

  .contact-info {
    .info-card {
      background: linear-gradient(145deg, 
        rgba(26, 26, 46, 0.95) 0%, 
        rgba(22, 33, 62, 0.95) 50%,
        rgba(26, 26, 46, 0.95) 100%
      );
      border-radius: 2rem;
      padding: 3rem;
      position: relative;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 2rem;
        padding: 1px;
        background: linear-gradient(135deg, 
          rgba(102, 126, 234, 0.5) 0%, 
          rgba(118, 75, 162, 0.3) 50%, 
          rgba(240, 147, 251, 0.5) 100%
        );
        -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        pointer-events: none;
      }

      .info-header {
        display: flex;
        align-items: center;
        gap: 1.5rem;
        margin-bottom: 2.5rem;

        .icon-wrapper {
          position: relative;
          width: 5rem;
          height: 5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 1.2rem;
          font-size: 2rem;

          .pulse {
            position: absolute;
            width: 100%;
            height: 100%;
            border-radius: 1.2rem;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            animation: pulse-ring 2s infinite;
          }

          @keyframes pulse-ring {
            0% {
              transform: scale(1);
              opacity: 0.5;
            }
            100% {
              transform: scale(1.5);
              opacity: 0;
            }
          }
        }

        h3 {
          font-size: 2rem;
          background: linear-gradient(135deg, #ffffff 0%, #b8b8ff 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
      }

      .contact-item {
        display: flex;
        align-items: center;
        gap: 1.5rem;
        padding: 1.5rem;
        background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
        border-radius: 1.2rem;
        transition: all 0.3s ease;

        &:hover {
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%);
          transform: translateX(5px);
        }

        img {
          width: 3rem;
          height: 3rem;
          padding: 0.5rem;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 0.8rem;
        }

        .contact-text {
          .label {
            display: block;
            font-size: 1.2rem;
            color: #888;
            margin-bottom: 0.3rem;
          }

          a {
            color: #e0e0e0;
            font-size: 1.4rem;
            font-weight: 500;
            transition: color 0.3s ease;

            &:hover {
              color: #f093fb;
            }
          }
        }
      }

      .divider {
        height: 1px;
        background: linear-gradient(90deg, 
          transparent, 
          rgba(102, 126, 234, 0.3), 
          rgba(240, 147, 251, 0.3), 
          transparent
        );
        margin: 2rem 0;
      }

      .social-section {
        h4 {
          font-size: 1.4rem;
          color: #b0b0b0;
          margin-bottom: 1.5rem;
          font-weight: 500;
        }

        .social-links {
          display: flex;
          gap: 1rem;

          .social-link {
            width: 5rem;
            height: 5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);
            border: 1px solid rgba(102, 126, 234, 0.3);
            border-radius: 1.2rem;
            transition: all 0.3s ease;

            img {
              width: 2.4rem;
              height: 2.4rem;
            }

            &:hover {
              transform: translateY(-5px);
              box-shadow: 0 10px 25px rgba(102, 126, 234, 0.3);
            }

            &.linkedin:hover {
              background: linear-gradient(135deg, rgba(0, 119, 181, 0.3) 0%, rgba(0, 119, 181, 0.2) 100%);
              border-color: rgba(0, 119, 181, 0.5);
            }

            &.github:hover {
              background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.1) 100%);
              border-color: rgba(255, 255, 255, 0.4);
            }

            &.twitter:hover {
              background: linear-gradient(135deg, rgba(29, 161, 242, 0.3) 0%, rgba(29, 161, 242, 0.2) 100%);
              border-color: rgba(29, 161, 242, 0.5);
            }
          }
        }
      }

      .availability {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-top: 2.5rem;
        padding: 1.2rem 1.5rem;
        background: linear-gradient(135deg, rgba(46, 213, 115, 0.1) 0%, rgba(46, 213, 115, 0.05) 100%);
        border: 1px solid rgba(46, 213, 115, 0.3);
        border-radius: 1rem;
        font-size: 1.3rem;
        color: #2ed573;

        .status-dot {
          width: 1rem;
          height: 1rem;
          background: #2ed573;
          border-radius: 50%;
          animation: blink 1.5s infinite;
        }

        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }
      }
    }
  }

  .form-section {
    height: 100%;
  }

  @media(max-width: 960px){
    .contact-wrapper {
      grid-template-columns: 1fr;
      gap: 3rem;
    }
  }

  @media(max-width: 480px){
    header {
      h2 {
        font-size: 2.8rem;
      }
    }

    .contact-info .info-card {
      padding: 2rem;
    }
  }
`
